import type { ConsumerConfig } from '../index';
import logo from './logo.svg';

/**
 * Wynn EBH consumer configuration.
 * Same branding as Wynn Las Vegas — shares logo and color palette.
 *
 * Cannot import from idme-assets directly: it is a Rails gem with no npm exports.
 * All values below are sourced from:
 *   idme-assets/app/assets/stylesheets/themes/wynn_ebh/_colors.scss
 *   idme-assets/app/assets/stylesheets/themes/wynn_ebh/_base.scss
 *
 * CSS overrides live in wynn_ebh/theme.scss (--consumer-* vars under .theme-wynn_ebh).
 */
export const wynnEbhConfig: ConsumerConfig = {
  themeClass: 'theme-wynn_ebh',
  logo: {
    src: logo,
    alt: 'Encore Boston Harbor, a Wynn Resort',
  },
  brand: {
    fontFamily: '"Avenir", sans-serif',  // $avenir in _base.scss
    colorPrimary: '#2E6D62',             // $action in _colors.scss
    colorTextPrimary: '#3C3C3C',         // $primary in _colors.scss
    colorTextSecondary: '#626262',       // $secondary in _colors.scss
  },
};
